// extracted by mini-css-extract-plugin
export default {"dashboard_circular_progress_spinner":"ProgressSpinner_dashboard_circular_progress_spinner__Yzf-o"};